/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
var React = require("react");
var IconSVG = /** @class */ (function (_super) {
    tslib_1.__extends(IconSVG, _super);
    function IconSVG() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconSVG.prototype.render = function () {
        return (React.createElement("svg", tslib_1.__assign({ role: "img", viewBox: "0 0 16 16" }, this.props),
            React.createElement("path", { d: "m8.08577602 5.25362733c.0266819-.0024028.05365916-.00362733.08089065-.00362733.55228475 0 1 .50367966 1 1.125v6.875h1.00000003c.5522847 0 1 .4477153 1 1s-.4477153 1-1 1h-4.00000003c-.55228475 0-1-.4477153-1-1s.44771525-1 1-1h1v-6h-1.16666667c-.55228475 0-1-.44771525-1-1s.44771525-1 1-1h2c.02889461 0 .057503.00122549.08577602.00362733zm-.21077602-1.33696066c-.80541526 0-1.45833333-.65291808-1.45833333-1.45833334s.65291807-1.45833333 1.45833333-1.45833333 1.45833333.65291807 1.45833333 1.45833333-.65291807 1.45833334-1.45833333 1.45833334z" })));
    };
    return IconSVG;
}(React.Component));
exports.IconSVG = IconSVG;